/**
 * v-log 坑位埋点指令
 */
import store from '../../store/index'
// import { setBuryPoint } from '../../api/Account'

export default {
  inserted(el, binding, vnode) {
    el.addEventListener(
      'click',
      event => {
        if (!el.disabled) {
          el.disabled = true
          // event.stopPropagation()
          let product = store.getters.businessType
          let page = store.state.app.pageName || ''
          // switch (location.hash.slice(2).split('/')[0]) {
          //   case 'collection':
          //     product = 'normal'
          //     break
          //   case 'marketing':
          //     product = 'promotion'
          //     break
          //   case 'info_check':
          //     product = 'ic'
          //     break
          // }
          const data = binding.value
          data.product = store.getters.businessType
          data.user_id = store.state.user.id || ''
          data.company_name = store.state.user.company || ''
          page && (data.page = page)
          // console.log(data)
          // setBuryPoint(data)
          //   .then(res => { })
          //   .finally(() => {
          //     setTimeout(() => {
          //       el.disabled = false
          //     }, 300)
          //   })
        }
      },
      false
    )
  }
}



// WEBPACK FOOTER //
// ./src/directive/track/log.js